import { QRCodeDownload as QRCodeDownloadSunrise } from 'src/app/shared/components/qrcodeSunrise';

import { usePetitionUrlQRCode } from './hooks/usePetitionUrlQRCode';

export function PetitionUrlQRCode() {
	const { data, actions } = usePetitionUrlQRCode();

	return (
		<div className="mt-6">
			<QRCodeDownloadSunrise
				value={data.value}
				descriptionText={data.descriptionText}
				downloadLinkText={data.downloadLinkText}
				downloadFilename={data.downloadFilename}
				onDownload={actions.handleDownload}
			/>
		</div>
	);
}
